import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from './button';

import styles from '../styles/uikitButtonsVotingButton.module.scss';

const VotingButton = ({
  className = '',
  downvoteTestId = '',
  iconSize = 24,
  isDownVoteDisabled = false,
  isDownVoted = false,
  isUpVoteDisabled = false,
  isUpVoted = false,
  onReplyVoteClicked = () => {},
  upvoteTestId = '',
  voteCountTestId = '',
  votesCount = 0,
}) => (
  <div className={classnames(styles.element, className)}>
    <Button
      variant="ghost"
      size="small"
      icon="voteUp"
      iconSize={iconSize}
      iconClass={isUpVoted ? styles.isActive : styles.isInactive}
      isDisabled={isUpVoteDisabled}
      onClick={() => onReplyVoteClicked('up')}
      testId={upvoteTestId}
    />
    <span className={styles.count} data-testid={voteCountTestId}>
      {votesCount}
    </span>
    <Button
      variant="ghost"
      size="small"
      icon="voteDown"
      iconSize={iconSize}
      iconClass={isDownVoted ? styles.isActive : styles.isInactive}
      isDisabled={isDownVoteDisabled}
      onClick={() => onReplyVoteClicked('down')}
      testId={downvoteTestId}
    />
  </div>
);

VotingButton.propTypes = {
  className: PropTypes.string,
  votesCount: PropTypes.number,
  iconSize: PropTypes.number,
  isUpVoted: PropTypes.bool,
  isDownVoted: PropTypes.bool,
  isUpVoteDisabled: PropTypes.bool,
  isDownVoteDisabled: PropTypes.bool,
  onReplyVoteClicked: PropTypes.func,
  upvoteTestId: PropTypes.string,
  downvoteTestId: PropTypes.string,
  voteCountTestId: PropTypes.string,
};

export default React.memo(VotingButton);
